import React, { useContext, useState, useRef, useEffect, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { Box, Button, Text, FormControl, Input, FlatList, Select } from 'native-base'

import { Context as LanguageContext } from '../../context/LanguageContext'
import { Context as AuthContext } from '../../context/AuthContext'
import { Context as MembersContext } from '../../context/MembersContext'

import {I18n} from 'i18n-js';
import AppTranslations from '../../../src/i18n/i18n'

import { applyMembersFilters, validateEmail } from '../../api/members';
import { hasOwnProperties } from '../../api/object';

const i18n = new I18n({
    ...AppTranslations
  });
  
i18n.enableFallback = true;

const MemberEmailFilter = () => {

    const authCtx = useContext(AuthContext)
    const membersCtx = useContext(MembersContext)
    
    const languageCtx = useContext(LanguageContext)
    i18n.locale = languageCtx.state;

    const [errors, setErrors] = useState({})

    const memberEmailInputRef = useRef()
    
    return <Box>

        {/* <Text>Errors: {JSON.stringify(errors)} </Text> */}
        
        <FormControl isInvalid={'email' in errors}>
            <FormControl.Label _text={{bold: true}}>
                {i18n.t('emailAddress')}
            </FormControl.Label>
            <Input placeholder={i18n.t('emailAddress')} 
                value={membersCtx?.state?.filters.email}                
                ref={memberEmailInputRef}
                onSubmitEditing={() => {
                    applyMembersFilters(membersCtx)
                    memberEmailInputRef.current.focus()
                }}
                onChangeText={value => {

                    const crtError = validateEmail(value)

                    if (hasOwnProperties(crtError)) {

                        setErrors({
                            ...errors,
                            ...crtError
                        })
                    } else {

                        delete errors.email
                        setErrors(errors)
                    }

                    membersCtx.setFilters({
                        ...membersCtx?.state?.filters, 
                        email: value
                    })    
                    
                }}
            />
            
            {
                'email' in errors ? 
                <FormControl.ErrorMessage _text={{fontSize: 'xs'}}>
                    { i18n.t(errors.email) }
                </FormControl.ErrorMessage> : null
                // <FormControl.HelperText _text={{fontSize: 'xs'}}>
                //     {i18n.t('msgNameIsMandatory')}
                // </FormControl.HelperText>
            }
        </FormControl>

    </Box>
};

const styles = StyleSheet.create({ 
    container: {
        borderWidth: 1
    },
    backgroundImage: {
        flex: 1
    }
})

export default MemberEmailFilter;